import { render } from "./App.vue?vue&type=template&id=3268154b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3268154b&lang=css"

import exportComponent from "D:\\myWork\\SAAS\\Group-Carwins-H5-1.0\\carwins-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__